module.exports = __webpack_public_path__ + "static/36542646_10216982573225444_705191685352587264_n-b5ca023fe4dd4dfdd605eb0b12cf41e6.jpg";